import { DynamicCapacityValuesOptions } from '@bringg/types';
import { get as _get, isNumber as _isNumber } from 'lodash';
import type { DynamicAggregationsTranslations, RoutesPlannerRun } from '@bringg-frontend/routes-planner';

export type DynamicAggregatedValues = {
	currentLoad?: number;
	expectedPickup?: number;
};

function getDynamicCapacityValue(run: RoutesPlannerRun, unitName: string, field: string): number | undefined {
	const hundred = 100;
	const fieldPostfix = unitName.split('.');
	fieldPostfix.splice(1, 0, field);
	const value = _get(run, `dynamic_aggregated_${fieldPostfix.join('.')}`);
	if (_isNumber(value)) {
		return Math.round(value * hundred) / hundred;
	}
}

function shouldDisplayDynamicCurrentLoad(dynamicCapacityMode: DynamicCapacityValuesOptions): boolean {
	return [DynamicCapacityValuesOptions.ALL, DynamicCapacityValuesOptions.CURRENT_LOAD].includes(dynamicCapacityMode);
}

function shouldDisplayDynamicExpectedPickup(dynamicCapacityMode: DynamicCapacityValuesOptions) {
	return [DynamicCapacityValuesOptions.ALL, DynamicCapacityValuesOptions.EXPECTED_PICKUP].includes(
		dynamicCapacityMode
	);
}

export function getDynamicAggregationValues(
	run: RoutesPlannerRun,
	dynamicCapacityMode: DynamicCapacityValuesOptions,
	unitName: string
): DynamicAggregatedValues {
	const result: DynamicAggregatedValues = {};
	if (shouldDisplayDynamicCurrentLoad(dynamicCapacityMode)) {
		result.currentLoad = getDynamicCapacityValue(run, unitName, 'current_load');
	}
	if (shouldDisplayDynamicExpectedPickup(dynamicCapacityMode)) {
		result.expectedPickup = getDynamicCapacityValue(run, unitName, 'expected_pickup');
	}
	return result;
}

export function buildDynamicAggregationHintText(
	aggregationValues: DynamicAggregatedValues,
	dynamicAggregationsTranslations: DynamicAggregationsTranslations
): string {
	let dynamicCapacityHint = '';
	if (aggregationValues.currentLoad != null) {
		dynamicCapacityHint += `${dynamicAggregationsTranslations.currentLoad}: ${aggregationValues.currentLoad}`;
	}
	if (aggregationValues.expectedPickup != null) {
		if (dynamicCapacityHint.length > 0) {
			dynamicCapacityHint += '\n';
		}
		dynamicCapacityHint += `${dynamicAggregationsTranslations.expectedPickup}: ${aggregationValues.expectedPickup}`;
	}
	return dynamicCapacityHint;
}
